import { createApp } from 'vue'
import Antd, { message } from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css'
const app = createApp(App)
import Table from "@/views/moving_function/components/table"

message.config({
  top: `100px`,
  duration: 2,
  maxCount: 3,
})

app.component('Table', Table)
app.use(store).use(router).use(Antd).mount('#app')